import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[vbFitParentSize]',
  exportAs: 'vbFitParentSize'
})
export class FitParentSizeDirective {

  @Input('vbFitParentSize')
  parent: HTMLElement;

  _view = [0, 0];

  get view(): any[] {

    let parentEl: HTMLElement = this.parent ? this.parent : this.el.nativeElement.parentElement;

    let width = parentEl.offsetWidth;
    this._view[0] = width;

    let height = parentEl.offsetHeight;
    this._view[1] = height;

    if (!width || !height || !this._view) {
      console.warn("View undefined", [this._view, parentEl]);
    }

    return this._view;

  }

  constructor(private el: ElementRef) {
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/directives/fit-parent-size.directive.ts